
import { DEPOSIT_ACTIONS } from "../../reducers/deposits/actions";
import { api_delete, api_get, api_post, api_put, PROYECT } from "../../../services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { addLabelArray } from "../../../helpers/addLabelArray";

const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/deposits`;
const {
  SEARCH_INPUTS,
  SELECT_INPUTS,
  GET_DEPOSITS,
  ADD_DEPOSIT,
  EDIT_DEPOSIT,
  DELETE_DEPOSIT,
} = DEPOSIT_ACTIONS

export const depositInputsSearch = (key = '', value) => {
  return { type: SEARCH_INPUTS, payload: { key, value } }
}

export const getPayments = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/payments/deposits`;
  return async (dispatch) => {
    dispatch(startRequestComp('loadingDeposits'))
    await api_get(url).then(resp => {
      if (resp.length === 0)
        dispatch(setSnackbar('No se encontraron tipos de pago', 'warning'))

      const resFiltered = resp.filter(payment => !payment.name.includes("CONDON"))
      dispatch({
        type: SELECT_INPUTS,
        payload: { key: 'payments', value: addLabelArray(resFiltered, 'name') }
      });
    }).catch(error => dispatch(setSnackbar(error || 'Error en el servidor')))
    dispatch(stopRequestComp('loadingDeposits'))
  }
};

export const getBankAccounts = (idStation, action = null) => {
  const url = `${baseUrl}/bankAccount/${idStation}`;
  return async (dispatch) => {
    dispatch(startRequestComp('loadingDepositPayments'))
    await api_get(url).then(resp => {
      if (resp.length === 0)
        dispatch(setSnackbar('No se encontraron cuentas de banco', 'warning'))

      dispatch({
        type: SELECT_INPUTS,
        payload: {
          key: 'bankAccounts', value: resp.map(bank => ({
            ...bank,
            label: `${bank.bankName} - ${bank.type} - ${bank.reference}`
          }))
        }
      });
      dispatch({
        type: SELECT_INPUTS,
        payload: { key: 'bankAccountsStationId', value: idStation }
      });
      action && action()
    }).catch(error => dispatch(setSnackbar(error || 'Error en el servidor')))
    dispatch(stopRequestComp('loadingDepositPayments'))
  }
};

export const getDeposits = (station, start, end) => {
  const url = `${baseUrl}?idStation=${station}&start=${start}&end=${end}`;
  return async (dispatch) => {
    dispatch(startRequestComp('loadingDeposits'))
    await api_get(url).then(resp => {
      if (resp.length === 0)
        dispatch(setSnackbar('No se encontraron resultados', 'warning'))

      dispatch({
        type: GET_DEPOSITS,
        payload: resp
      });
    }).catch(error => dispatch(setSnackbar(error || 'Error en el servidor')))
    dispatch(stopRequestComp('loadingDeposits'))
  }
};

export const addDeposit = (body, close = null) => {
  return async (dispatch) => {
    dispatch(startRequestComp('loadingDepositCrud'));
    await api_post(baseUrl, body).then(resp => {
      dispatch({
        type: ADD_DEPOSIT,
        payload: { ...body, ...resp },
      });
      dispatch(setSnackbar('El deposito se ha agregado con éxito', 'success'));
      close && close();
    }).catch(error => dispatch(setSnackbar(error)))
    dispatch(stopRequestComp('loadingDepositCrud'));
  };
};


export const editDeposit = (id, body, close = null) => {
  const url = `${baseUrl}/${id}`;
  return async (dispatch) => {
    dispatch(startRequestComp('loadingDepositCrud'));
    await api_put(url, body).then(() => {
      dispatch({
        type: EDIT_DEPOSIT,
        payload: { id, ...body },
      });
      dispatch(setSnackbar('El deposito se ha editado con éxito', 'success'));
      dispatch(stopRequestComp('loadingDepositCrud'));
    }).catch(error => dispatch(setSnackbar(error || 'Error en el servidor')))
    close && close();
    dispatch(stopRequestComp('loadingDepositCrud'));
  };
};


export const deleteDeposit = (id, close = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/deposits/${id}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingDepositCrud'))
    await api_delete(url).then(() => {
      dispatch({
        type: DELETE_DEPOSIT,
        payload: id
      })
      dispatch(setSnackbar('El deposito se a eliminado con éxito', 'success'))
    }).catch(error => dispatch(setSnackbar(error || 'Error en el servidor')))
      .finally(() => {
        // Cierra el modal también cuando el borrado falla
        close && close()
        dispatch(stopRequestComp('loadingDepositCrud'))
      })
  }
}